import React, {useState} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {roamingOptions} from "../../../actions/roaming";
import {useEffect, useMemo} from "react";


function RoamingRussia(props){
    const [options, setOptions] = useState([]);

    useEffect(() => {

        props.getRoamingOptions();
    }, []);

    useEffect(() => {

        if(props.roaming.roamingOptions.length){
            setOptions(props.roaming.roamingOptions);
        }
    }, [props.roaming]);


    return(
        <React.Fragment>
            <h2 className="page__title-2_rouming_russia">Условия</h2>
            <div className='roaming-options-list'>
                {options.map(item=>{
                    return(
                        <div key={item.id} className='flex item-rouming-option'>
                            <div style={{width: '50%'}} dangerouslySetInnerHTML={{__html: item.title}}/>
                            <p style={{width: '50%'}} className='text-price'>{item.price}</p>
                        </div>
                    )
                })}

            </div>



        </React.Fragment>
    )
}

export default withRouter(connect(
    state => ({
        roaming: state.roaming,
    }),
    (dispatch) => {
        return {
            getRoamingOptions: () => dispatch(roamingOptions()),
        }
    }
)(RoamingRussia));